type SingleCharacteristicValue = {
	name: string;
	value?: string;
};

export type SingleResource = {
	resourceCharacteristicValue: SingleCharacteristicValue[];
	resourceSpecification: SingleCharacteristicValue;
};

const model: types.models.InputModel = {
	resourceCharacteristicValue: ['resourceCharacteristicValue', []],
	resourceSpecification: 'resourceSpecification',
};

export default model;
